import fortilineLogo from "../assets/img/fortiline-logo.png";
import reeceLogo from "../assets/img/logo.png";
import { IconButton, Menu, MenuItem } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { useAuthStore } from "../Zustand/auth.store";
import { useNavigate } from "react-router-dom";

export const NavBar = () => {
  /**
   * Custom hooks
   */
  const { logout } = useAuth();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isAdmin = useAuthStore((s) => s.isAdmin);
  const navigate = useNavigate();

  /**
   * States
   */
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  /**
   * Callbacks
   */
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    handleClose();
    await logout();
  };
  const handleManageRequests = () => {
    handleClose();
    navigate("/admin");
  };

  return (
    <>
      <nav className="bg-white p-4 sticky top-0 z-50">
        <div className="container mx-auto flex items-center">
          <div className="flex-grow-0 flex space-x-4 items-center">
            <img className="w-36" src={reeceLogo} alt="logo" />
            <div className="border-l border-gray-300 h-9 mx-4" />
            <img className="w-52" src={fortilineLogo} alt="Fortiline logo" />
          </div>
          <div className="flex-grow"></div>
          <h3 className="text-end flex-grow-0">Spec Library</h3>
          {isAuthenticated && (
            <div className="flex-grow-0 ml-4">
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                onClick={handleMenu}
                aria-controls={open ? "user-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <AccountCircle fontSize="large" sx={{ color: "#6C757D" }} />
              </IconButton>
              <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                {isAdmin && (
                  <MenuItem onClick={handleManageRequests}>
                    Manage requests
                  </MenuItem>
                )}
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};
